// Phase 19.15 — Banner shown at the top of the app when an Owner is
// previewing as a portal user. Single Exit button restores normal session.
import React from "react";
import { Eye, LogOut } from "lucide-react";
import { Button } from "./ui/button";
import {
  getImpersonationId,
  getImpersonationTarget,
  exitImpersonation,
} from "../lib/impersonation";

const ImpersonationBanner = () => {
  const id = getImpersonationId();
  const target = getImpersonationTarget();
  if (!id || !target) return null;

  const exit = () => {
    exitImpersonation();
    window.location.reload();
  };

  const label = target.name || target.email || "Portal user";
  const subtitle =
    target.account_type === "client_portal"
      ? "Client Portal"
      : target.account_type === "employee_portal"
      ? "Employee Portal"
      : target.account_type || "";

  return (
    <div
      className="w-full bg-amber-500/95 text-white text-sm shadow-md flex items-center justify-center gap-3 px-4 py-2"
      data-testid="impersonation-banner"
      role="status"
    >
      <Eye className="h-4 w-4 shrink-0" />
      <span className="font-medium truncate">
        Previewing as <span className="underline underline-offset-2">{label}</span>
        {subtitle ? <span className="opacity-80"> · {subtitle}</span> : null}
      </span>
      <Button
        variant="secondary"
        size="sm"
        onClick={exit}
        className="h-7 px-2 bg-white text-amber-700 hover:bg-amber-50 ml-2"
        data-testid="impersonation-exit-btn"
      >
        <LogOut className="h-3.5 w-3.5 mr-1" />
        Exit Preview
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
